import { render, staticRenderFns } from "./extract-capital.vue?vue&type=template&id=d347b0b2&scoped=true&"
import script from "./extract-capital.vue?vue&type=script&lang=js&"
export * from "./extract-capital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d347b0b2",
  null
  
)

export default component.exports